// // Numbers
export const onlyNumbers = /^[0-9]*$/;
export const onlyNumbersMessage = 'יש להקליד ספרות בלבד';

export const noNumbersNSymbols = /[0-9!@#$%^&*()]/;

// // Email
export const email = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
export const emailWithEmpty = /^$|\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
export const emailMessage =
  'יש להקליד אותיות באנגלית ואת הסימן @ בלבד, ללא רווחים';

// // letters or numbers no special chars
// export const lettersOrNumbersNoSpecialChars =
//   /^[a-zA-Z0-9א-ת-|'|" ]*$/gi;
// export const lettersOrNumbersNoSpecialCharsMessage =
//   'יש להקליד אותיות או ספרות בלבד, ללא תווים מיוחדים';

// letters or numbers with some special chars
export const lettersOrNumbersWithSomeExtraChars =
  /^[a-zA-Z0-9א-ת|(()())'".?! ,]*$/g;
export const illegalChars = /[^a-zA-Z0-9א-ת\-.?!\n/ ,)(]/gi;

export const lettersOrNumbersWithSomeExtraCharsMessage =
  ' ניתן להקליד אותיות בעברית ובאנגלית, מספרים ואת התווים הבאים: , ! ? .';

// // letters or numbers with all special chars
// export const lettersOrNumbersWithExtraChars =
//   /^[a-zA-Z0-9א-ת-|.|,|(|)|?|!|:|'|"|\n ]*$/gi;
// export const lettersOrNumbersWithExtraCharsMessage =
//   'יש להקליד אותיות או ספרות בלבד, ללא תווים מיוחדים';

// //Phone
// export const phoneNumberNotRequired = /^$|(\S{7})/;
export const phoneNumberMessage = 'חייב להכיל 7';

// //Misc
export const textTooLong = (textLength: number) =>
  `הטקסט שהקלדת ארוך מידי. מספר התווים המירבי הוא ${textLength}`;
export const textLengthMustBe = (textLength: number) =>
  `חייב להכיל ${textLength} ספרות`;
export const requiredMessage = 'יש למלא';
export const requiredFieldMessage = 'שדה חובה';
export const requiredPhoneMessage = 'יש למלא מספר טלפון';
export const requiredPrefixMessage = 'יש למלא קידומת';
// export const exactlyNumOfChars = (numOfChars: number) =>
//   `יש להזין ${numOfChars} תווים במדויק`;

export const notDigits = /[^0-9]/g;
export const phone = /[0-9]{7,8}/g;
// export const phoneMessage = 'ניתן להקליד מספרים בלבד';

// File name validation
export const fileName = /[^a-zA-Z0-9\u05D0-\u05EA\- _]/g;

// Israeli ID
export const isValidIsraeliID = (idString: string) => {
  var id = idString.trim();
  if (id.length > 9 || id.length < 4 || isNaN(parseInt(id))) return false;
  id = id.length < 9 ? ('00000000' + id)?.slice(-9) : id;
  return (
    Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }) %
      10 ===
    0
  );
};

// Returns true if a string is written in hebrew otherwise false. Regular symbols are allowed: ? ! , . %
export const isHebrew = (str: string) => {
  const hebrewRegex = /^[א-ת\s?!%,.-]+$/;
  return hebrewRegex.test(str);
};

export const noNumbersAndSymbols = (str: string) => {
  return noNumbersNSymbols.test(str);
};

export const isPhoneNumber = (str: string) => {
  const phoneRegex = /^\d{7,8}$/;
  return phoneRegex.test(str);
};

export const isValidEmail = (str: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(str);
};

export const validateIsraeliIdMessage = 'מספר תעודת זהות לא תקין';

export const emailSanitation = /[^a-zA-Z0-9\u05D0-\u05EA|(()())'".?! ,@]/g;
